/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable dot-notation */
import {
  Col, Container, Inline, Row, Tooltip, Typography,
} from '@airbus/components-react';
import { Dispatch } from 'redux';
import { chipConstants } from '../Shared/ChipLabel/constants';
import {
  ATA,
  FIN_STATUS_MAPPER,
  SELECT_STATUS,
  MSN_AIRCRAFT_REGISTRATION,
  MULTIPLE_VALUES,
  PART_NUMBER_COUNT_TEXT_MIS,
  CURRENT_PART_NUMBER,
  CURRENT_RESULTS,
  FIN_ACCESS_PANEL,
  FIN,
} from '../../utils/constants';
import CheckerFinEditStatusComponent from './CheckerFinEditStatusComponent';
import InfoTooltip from '../InfoTooltip/InfoTooltip';
import { useAppSelector } from '../../store/hooksTypes';

interface FinStatusInterface {
  statusProps: CheckerSelectedFinDataType;
  checkerDataTableState: any
  CheckerFinEditModalPopupDispatcher: Dispatch<any>;
  featureToggle: boolean;
  applyAllToggleState: boolean;
  selectedFin: any[];
}
const CheckerFinStatusComponent = ({
  statusProps, checkerDataTableState, CheckerFinEditModalPopupDispatcher, featureToggle, applyAllToggleState, selectedFin,
}: FinStatusInterface) => {
  const finStatus: string = chipConstants[FIN_STATUS_MAPPER[statusProps.fin_status]].chipText;
  let partNumber = statusProps.part_number.join(', ').split(', ');
  partNumber = Array.from(new Set(partNumber));
  const pnrTooltip = partNumber.join(', ');
  const featureToggleConfig = useAppSelector((state) => state.featureToggleDetails?.data);
  const featureToggleAccessPanel = featureToggleConfig?.access_panel === 'true';
  return (
    <Container className="fin-status-container">
      <Row>
        <Col xs={2}>
          <Typography variant="small" className="fin-status-header-label">{featureToggleAccessPanel ? FIN_ACCESS_PANEL : FIN}</Typography>
          <Typography variant="small" className="fin-status-header-value">
            {statusProps.fleet_fin?.startsWith('ZZZZ_') ? 'No FIN' : statusProps.fleet_fin}
          </Typography>
        </Col>
        <Col xs={2}>
          <Typography variant="small" className="fin-status-header-label">{CURRENT_RESULTS}</Typography>
          <Typography variant="small" className="fin-status-header-value">{finStatus}</Typography>
        </Col>
        <Col xs={2}>
          <Typography variant="small" className="fin-status-header-label">{MSN_AIRCRAFT_REGISTRATION}</Typography>
          <Typography variant="small" className="fin-status-header-value">{statusProps.id_aircraft_registration}</Typography>
        </Col>
        <Col xs={2}>
          <Typography variant="small" className="fin-status-header-label">{ATA}</Typography>
          {statusProps.ata?.startsWith('ZZZZ') ? (
            <InfoTooltip classname="ata-tool" labeltext={MULTIPLE_VALUES} />
          ) : (
            <Typography variant="small" className="fin-status-header-value">{statusProps.ata}</Typography>
          )}
        </Col>
        <Col xs={3} className="fin-inline">
          <Inline
            spacing="half-x"
          >
            <Typography variant="small" className="fin-status-header-label">
              {CURRENT_PART_NUMBER}
            </Typography>
            {featureToggle && statusProps.pnr_count > '1' && <InfoTooltip classname="pnr-text-count-tool" labeltext={`${statusProps.pnr_count} ${PART_NUMBER_COUNT_TEXT_MIS}`} infoClassname="part-info" />}
          </Inline>
          {partNumber.length > 1 ? (
            <Tooltip placement="bottom" label={pnrTooltip} className="pnr-text-tool">
              <Typography variant="small" className="fin-status-header-value">
                <span className="fin-history-pnr">{pnrTooltip}</span>
              </Typography>
            </Tooltip>
          ) : (
            <Typography variant="small" className="fin-status-header-value">{pnrTooltip}</Typography>
          )}
        </Col>
      </Row>
      <Row className="changes-fin">
        <Col xl={2}>
          <Typography variant="small" className="select-status-header-label">{SELECT_STATUS}</Typography>
        </Col>
      </Row>
      <CheckerFinEditStatusComponent
        statusProps={statusProps}
        checkerDataTableState={checkerDataTableState}
        CheckerFinEditModalPopupDispatcher={CheckerFinEditModalPopupDispatcher}
        featureToggle={featureToggle}
        applyAllToggleState={applyAllToggleState}
        selectedFin={selectedFin}
      />
    </Container>
  );
};
export default CheckerFinStatusComponent;
